/* eslint-disable no-unused-expressions */
import { iam } from 'codemash';
import { Config } from 'configs';
import { getErrorMessage } from 'utils/errorHandler';
import { apiActionChooser } from 'utils/apiActionChooser';
import { changePasswordRequest, getProfileRequest, postLogin } from './client/requests';

export const checkAuthentication = async ({ token, alertController }) => {
  try {
    const response = await iam.checkAuthentication({ secretKey: token });

    return response;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error occured', e);

    if (alertController) {
      alertController.error(getErrorMessage(e));
    }
  }

  return null;
};

export const getProfile = async ({ token, useV2, alertController }) => {
  try {
    let userResponse;

    if (useV2) {
      userResponse = await getProfileRequest();
    } else {
      userResponse = await iam.getProfile({
        secretKey: token,
        includeMeta: true,
        includeUnreadNotifications: true,
      });
    }

    return userResponse;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error occured', e);

    if (alertController) {
      alertController.error(getErrorMessage(e));
    }
  }

  return null;
};

export const login = async ({ email, password, useV2, alertController }) => {
  try {
    let response;

    if (useV2) {
      response = await postLogin({
        data: {
          username: email,
          password,
        },
        path: '/users/v1/login',
      });
    } else {
      response = await iam.login({
        secretKey: Config.CODEMASH.SECRET_KEY,
        username: email,
        password,
      });
    }

    return response;
  } catch (e) {
    if (e.name === 'Unauthorized' || e.name === 'Forbidden' || e.name === 'UserDeactivated') {
      throw e;
    }

    Config.SHOW_LOGS && console.log('Error occured', e);

    if (alertController) {
      alertController.error(getErrorMessage(e));
    }
  }

  return null;
};

export const logout = async ({ token }) => {
  try {
    await iam.logout({ secretKey: token, mode: 'default', provider: 'credentials' });
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error occured', e);
  }
};

export const changePassword = async ({
  token,
  password,
  newPassword,
  alertController,
  companyId,
}) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await iam.updatePassword({
          secretKey: token,
          password: newPassword,
          repeatedPassword: password,
          currentPassword: password,
        });
      },
      async () => {
        response = await changePasswordRequest({
          password,
          newPassword,
        });
      },
    );

    return response;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error occured', e);

    if (alertController) {
      alertController.error(getErrorMessage(e));
    }
  }

  return null;
};
